enum Classifier {
  //equipment classifiers
  SELF_PROPELLED_MACHINERY = 'self_propelled_machinery',
  MACHINES_AND_AGGREGATES = 'machines_and_aggregates',

  //human classifiers
  FORMS_OF_ECONOMIC_ACTIVITY = 'forms_of_economic_activity',

  //finance
  LIVESTOCK_PRODUCTION_MODELS = 'livestock_production_models',
  CROP_PRODUCTION_MODELS = 'crop_production_models',

  //warehouse classifiers
  PLANT_PROTECTION_PRODUCTS = 'plant_protection_products',
  CROP_GROUPS = 'crop_groups',
  LIVESTOCK_SECTORS = 'livestock_sectors',
  FERTILIZERS = 'fertilizers',
  WAREHOUSE_TYPES = 'warehouse_types',
  PRODUCT_CATEGORIES_AND_TYPES = 'product_categories_and_types',
  PRODUCT_TYPES = 'product_types',
  OBTAINED_PRODUCT_CATEGORIES_AND_TYPES = 'obtained_product_categories_and_types',
  OBTAINED_PRODUCT_TYPES = 'obtained_product_types',
  VAT_RATES = 'vat_rates',
  PREPACKAGES_FOR_VETERINARY_MEDICINES = 'prepackages_for_veterinary_medicines',

  //crop classifiers
  CROP_WORKS = 'crop_works',
  SOIL_GRANULOMETRIC_COMPOSITION = 'soil_granulometric_composition',
  PLANT_DEVELOPMENT_STAGES = 'plant_development_stages',
  OWNERSHIP = 'ownership',

  //livestock classifiers
  ANIMALS = 'animals',
  ANIMAL_SPECIES = 'animal_species',
  ANIMAL_CATEGORIES = 'animal_categories',
  TIME_OF_USE = 'time_of_use',
  CORRECTION_BY_GREEN_MANURE_TYPE = 'correction_by_green_manure_type',
  INVESTIGATION_METHODS = 'investigation_methods',
  WEIGHT_TYPES = 'weight_types',
}

export default Classifier;
